import { UPDATE_MAINTENANCES } from '../constants';

const DEFAULT_STATE = {
  maintenances: {},
};

const MaintenancesReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_MAINTENANCES:
      payload.forEach(
        (maintenance) => (state.maintenances[maintenance.id] = maintenance)
      );
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default MaintenancesReducer;
